
import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useDeleteVegetable, useGetAllVegetables } from '../hooks/hooks';
import "react-loading-skeleton/dist/skeleton.css";
import AddVegetablesModal from '../modal/AddVegetablesModal';
import { DeleteIcon, EditIcon, NDVegetableI } from '../assets/icons/icon';
import { ButtonWithIcon } from '../components/Common/Buttons';
import EntityListPage from '../components/Common/EntityListPage';

function VegetablesCopy() {
  const { t } = useTranslation();
  
  const getUnitTypes = (unitType) => {
    switch (unitType.toLowerCase()) {
      case 'gram':
        return 'ગ્રામ (Gram)';
      case 'kgs':
        return 'કિગ્રા (KGS)';
      case 'liter':
        return 'લિટર (Liter)';
      case 'ml':
        return 'મિલીલીટર (ML)';
      case 'pieces':
        return 'નંગ (Pieces)';
      default:
        return unitType;
    }
  }

  const filterFn = useCallback((list, searchText) => {
    if (!searchText.trim()) return list;

    const v = searchText.toLowerCase();

    return list.filter(item =>
      item.name?.toLowerCase().includes(v)
    );
  }, []);

  const VegetableCard = ({ item, index, onEdit, onDelete }) => (
    <div className="bg-white rounded-xl shadow-card border border-gray-100 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 p-6">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {item.name}
          </h3>
          <div className="flex items-center gap-2">
            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
            </svg>
            <span className="text-sm text-gray-600">{getUnitTypes(item.unitType)}</span>
          </div>
        </div>
        <div className="flex items-center gap-[2px]">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} iconClass="text-green-600 mr-0" btnclass="p-[5px] hover:bg-green-50 rounded-md transition-all border border-green-300" onClick={onEdit} />
          <ButtonWithIcon title="Edit" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0 text-red-500" btnclass="p-[5px] text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );

  const TableRow = ({startIndex, item, index, onEdit, onDelete }) => (
    <div
      className={`w-full flex py-4 font-medium text-sm text-gray-700 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200
          ${index % 2 === 0 ? "bg-gray-50/50" : "bg-white"}`}
    >
      <div className="w-[10%] pl-6 flex items-center font-medium text-gray-500">{startIndex + index + 1}</div>
      <div className="w-[45%] flex items-center pr-4">
        <div className="font-semibold text-gray-900 truncate" title={item.name}>{item.name}</div>
      </div>
      <div className="w-[35%] flex items-center pr-4">
        <div className="text-gray-700 truncate" title={getUnitTypes(item.unitType)}>{getUnitTypes(item.unitType)}</div>
      </div>
      <div className="w-[10%] flex items-center">
        <div className="flex items-center gap-2">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} btnclass="p-2 text-green-600 hover:bg-green-50 rounded-md transition-all border border-green-300" iconClass="mr-0" onClick={onEdit} />
          <ButtonWithIcon title="Edit" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0" btnclass="p-2 text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );

  const getNoDataDesc = useCallback((searchText) => {
      return searchText ? 'Try adjusting your search terms' : 'Get started by adding your first vegetable';
    }, []);

  return (
    <>
      <EntityListPage
        title={t('vegetable')}
        subtitle={t('manage_your_vegetable_inventory_and_categories')}
        addButtonText={t('add_new_vegetable')}
        searchPlaceholder={t('search_Vegetable_lbl')}

        fetchHook={useGetAllVegetables}
        deleteHook={useDeleteVegetable}
        filterFn={filterFn}

        tableColumns={[
          { key: "#", label: "#", className: "w-[10%]", width: 50 },
          { key: "name", label: t('vegetable_name'), className: "w-[45%]", width: 200 },
          { key: "unit", label: t('unitType'), className: "w-[35%]", width: 150 },
          { key: "action", label: t('Action'), className: "w-[10%]", width: 80 },
        ]}

        TableRow={TableRow}
        Card={VegetableCard}
        AddEditModal={AddVegetablesModal}

        getNoDataDesc={getNoDataDesc}
        emptyIcon={<NDVegetableI />}
        emptyText="No vegetables found"
        buttonText={'Add Vegetable'}
        deleteMsg={t('delete_veg_confirmation_msg')}
      />
    </>
  )
}

export default VegetablesCopy

